/* global axios */
import ApiClient from './ApiClient';

class LossReasonsAPI extends ApiClient {
  constructor() {
    super('loss_reasons', { accountScoped: true });
  }

  getAll(activeOnly = false) {
    const params = activeOnly ? { active_only: true } : {};
    return axios.get(this.url, { params });
  }

  reorder(positions) {
    return axios.post(`${this.url}/reorder`, { positions });
  }
}

export default new LossReasonsAPI();
